<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eeWta6/tc-custom/9781626814363.jpg?1734324039836" alt="This image is the cover for the book Fashionably Late"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fashionably Late
      </h1>
      <p class="bookDescription body article font2">
        <b>A clothes designer tries to coordinate her out-of-control life, in a novel from the <i>New York Times</i>–bestselling author that’s “juicy good fun” (<i>Newsday</i>).</b><br/>  <br/> All of Karen Kahn’s dreams seem to be coming true. She’s been honored with the fashion industry’s most coveted award, her marriage is thriving, and some very impressive money is being dangled in front of her in a proposed buyout. The only thing missing is what she craves most—a baby. When she receives the heartbreaking news that she’ll never be able to have a child, it feels like the doctor’s verdict has pulled a loose thread—and suddenly everything seems to be unraveling. Now she has to take a hard look at her life and figure out what really suits her and what doesn’t . . .<br/>  <br/> “This new novel by the author of <i>The First Wives Club</i> works at every level. An engaging, behind-the-scenes look at the fashion industry, it lays bare the frenetic pace, cutthroat competition and chronic backbiting of the world of couture. Also an engrossing family saga, it shows 40-year-old Karen, who is infertile, desperately trying to adopt a baby and, as an adopted child herself, searching for her birth mother. The narrative also offers a hilariously dark portrait of Karen’s immediate—and totally dysfunctional—family. A glittering New York social backdrop, plenty of namedropping, romance, some outstandingly creative characters . . . A book that fairly hums with excitement.” —<i>Publishers Weekly</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Olivia Goldsmith
      </h2>
      
      <p class="authorDescription body article">Olivia Goldsmith (1949&ndash;2004) was an American author, best known for her first novel <I>The First Wives Club</I> (1992), which was adapted into a movie in 1996.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?67371906